import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import blogs from "../../api/blogs";
import BlogSingle from "../BlogSingle";
import { Link } from "react-router-dom";
import "./style.css";

const MediaSection = () => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({});

  const handleClose = () => setOpen(false);
  const handleClickOpen = (item) => {
    setOpen(true);
    setState(item);
  };

  const sliderSettings = {
    dots: true,
    arrows: false,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  const BlogCard = ({ blog }) => (
    <div
      className="tp-blog-item media-card-clickable"
      onClick={() => handleClickOpen(blog)}
    >
      <div className="tp-blog-img">
        <img src={blog.screens} alt="" />
        <div className="mt-4">{blog.thumb}</div>{" "}
        {/* classname .thumb removed from this div */}
      </div>
      <div className="tp-blog-content">
        <ul>
          <li>{blog.create_at}</li>
          <li>By {blog.author}</li>
        </ul>
        <h2 className="media-card-title">{blog.title}</h2>
        <p>{blog.description}</p>
      </div>
    </div>
  );

  return (
    <section className="tp-blog-section section-padding" id="blog">
      <div className="container">
        <div className="tp-section-title">
          <span>Media</span>
          <h2>Featured In Leading Media Platforms</h2>
        </div>

        {/* Desktop: 4-column grid */}
        <div className="tp-blog-items media-grid-desktop">
          <div className="row">
            {blogs.map((blog, bl) => (
              <div className="col-lg-3 col-12" key={bl}>
                <BlogCard blog={blog} />
              </div>
            ))}
          </div>
        </div>

        {/* Tablet + Mobile: carousel */}
        <div className="media-carousel-mobile">
          <Slider {...sliderSettings}>
            {blogs.map((blog, bl) => (
              <div key={bl} className="media-carousel-slide">
                <BlogCard blog={blog} />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="visible-rotate-text">
        <h1>Media</h1>
      </div>

      <BlogSingle
        open={open}
        onClose={handleClose}
        title={state.title}
        bImg={state.blogSingleImg}
        create_at={state.create_at}
        author={state.author}
        comment={state.comment}
        mediaRedirectLink={state.mediaRedirectLink}
      />
    </section>
  );
};

export default MediaSection;
